import type { PostepRozmowy } from "@shared/recenzjeTypy.js";
import { opisPostepu, procentPostepu } from "../../lib/recenzja.js";

/**
 * Pasek "N z M wskazan": tor i wypelnienie z gotowych klas PR-2 (.progress-track, .progress-fill). Liczba jest tez
 * w aria-valuenow, wiec czytnik ekranu dostaje ten sam komunikat co oko.
 */
export function PasekPostepu({
  postep,
  etykieta = "Postęp przeglądu",
}: {
  postep: Pick<PostepRozmowy, "ocenionych" | "wskazan">;
  etykieta?: string;
}): React.JSX.Element {
  return (
    <div
      className="progress-track rec-pasek"
      role="progressbar"
      aria-label={etykieta}
      aria-valuemin={0}
      aria-valuemax={Math.max(1, postep.wskazan)}
      aria-valuenow={postep.ocenionych}
      aria-valuetext={opisPostepu(postep)}
    >
      <div className="progress-fill" style={{ width: `${procentPostepu(postep)}%` }} />
    </div>
  );
}
